import { hapticFeedback, ImpactHapticFeedbackStyle } from "@tma.js/sdk-react";

export const haptic = (impact: ImpactHapticFeedbackStyle) => {
  if (hapticFeedback.impactOccurred.isAvailable()) {
    hapticFeedback.impactOccurred(impact);
  }
};
